import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {TenantPermissions} from "../_models/tenantPermissions";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class TenantPermissionsService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getAllTenantPermissions() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenantpermissions/all' + '');
  }
  getTenantPermissionsNameBySecret(secret: string) {
    return this.http.get<any>(this.config.api + '/api/tenantpermissionsName/' + secret);
  }
  getTenantPermissions(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenantpermissions/' + id + '');
  }

  @Load()
  addTenantPermissions(tenantPermissions: TenantPermissions) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.put(this.config.api + '/api/tenantpermissions', tenantPermissions);
  }

  @Load()
  updateTenantPermissions(tenantPermissions:TenantPermissions) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenantpermissions', tenantPermissions);
  }

  getCurrentTenantPermissions() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }
    return this.http.get<any>(this.config.api + '/api/tenantpermissions/current')
      ;
  }

  @Load()
  deleteTenantPermissions(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/tenantpermissions/' + id + '');
  }
}
